//
//  useActionAlert.ts
//
//  isana.net,inc. Proprietary and Confidential
//

import { useState, useEffect } from "react";
type MessageType = "success" | "error" | "";
const useActionAlert = (duration: number = 3000) => {
  const [message, setMessage] = useState("");
  const [type, setType] = useState<MessageType>("");
  const showMessage = (msg: string, msgType: MessageType) => {
    setMessage(msg);
    setType(msgType);
  };
  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(() => {
      setMessage("");
      setType("");
    }, duration);
    return () => clearTimeout(timer);
  }, [message, type, duration]);
  return { message, type, showMessage };
};
export default useActionAlert;
